import { t } from "../../validation/validator";

export const stripeCouponDurationSchema = t.union([t.literal("forever"), t.literal("once"), t.literal("repeating")]);
export type StripeCouponDuration = t.TypeOf<typeof stripeCouponDurationSchema>;

export const couponResponseSchema = t.intersection([
  t.partial({ currency: t.union([t.string, t.null]) }),
  t.type({
    promoId: t.string,
    id: t.string,
    duration: stripeCouponDurationSchema,
    discount: t.number,
    amountOff: t.union([t.number, t.null]),
    promoName: t.string,
    restrictions: t.type({
      minimum_amount: t.union([t.number, t.null]),
      minimum_amount_currency: t.union([t.string, t.null]),
    }),
  }),
]);
export type CouponResponse = t.TypeOf<typeof couponResponseSchema>;

export const stripeMinimumCouponSchema = t.type({
  id: t.string,
  name: t.union([t.string, t.null]),
  amount_off: t.union([t.number, t.null]),
  percent_off: t.union([t.number, t.null]),
  duration: stripeCouponDurationSchema,
});
export type StripeMinimumCoupon = t.TypeOf<typeof stripeMinimumCouponSchema>;

export const stripeCouponSchema = t.type({
  id: t.string,
  name: t.string,
  amount_off: t.number,
  percent_off: t.number,
  duration: t.string,
  duration_in_months: t.number,
  livemode: t.boolean,
  created: t.number,
  max_redemptions: t.number,
  metadata: t.record(t.string, t.string),
  redeem_by: t.number,
  times_redeemed: t.number,
  valid: t.boolean,
  currency: t.union([t.string, t.null]),
});
export type StripeCoupon = t.TypeOf<typeof stripeCouponSchema>;

export const stripeGetCouponRequestSchema = t.partial({
  couponId: t.string,
  promoCode: t.string,
  skipUsageCheck: t.boolean,
});
export type StripeGetCouponRequest = t.TypeOf<typeof stripeGetCouponRequestSchema>;
